<template>
  <div class="vx-row">
    <div class="vx-col w-full lg:w-1/2">
      <div class="bi-campaign--info-box">
        <h3 class="mb-5">Stellendaten</h3>
        <div v-for="vacancy of internalValue" :key="vacancy.id" class=" mb-10">
          <h4>{{ vacancy.number }} - {{ vacancy.title }}</h4>
          <VacancyStat :number="vacancy.number"></VacancyStat>
        </div>
      </div>
    </div>
    <div class="vx-col w-full lg:w-1/2">
      <div class="bi-campaign--info-box">
        <h3 class="mb-5">Stellenvergleich</h3>
        <VacancyStatsMulti
          :numbers="internalValue.map(el => el.number)"
          class="mb-5"
        />
        <VacancyCompareChart
          :numbers="internalValue.map(el => el.number)"
          metric="VISITORS"
          header="Besucher der letzten Woche"
          class="mb-5"
        />
        <VacancyCompareChart
          :numbers="internalValue.map(el => el.number)"
          metric="APPLICATIONS_SENT"
          header="Bewerbungen der letzten Woche"
          class="mb-5"
          @chartDataSet="
            values =>
              $emit(
                'applicantNumberSet',
                values.reduce(
                  (accumulator, currentValue) => accumulator + currentValue
                )
              )
          "
        />
        <VacancySourceChart
          :numbers="internalValue.map(el => el.number)"
          metric="VISITORS"
          header="Besucherquellen der letzten Woche"
          class="mb-5"
        />
        <VacancySourceChart
          :numbers="internalValue.map(el => el.number)"
          metric="APPLICATIONS_SENT"
          header="Bewerberquellen der letzten Woche"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VacancyStat from "../../stats/VacancyStat";
import VacancyStatsMulti from "../../stats/VacancyStatsMulti";
import VacancyCompareChart from "../../stats/VacancyCompareChart";
import VacancySourceChart from "../../stats/VacancySourceChart";

export default {
  components: {
    VacancyStat,
    VacancyStatsMulti,
    VacancyCompareChart,
    VacancySourceChart
  },
  props: {
    value: { type: Array, required: true }
  },
  emits: ["applicantNumberSet"],
  computed: {
    internalValue: {
      get() {
        return this.value;
      }
    }
  },
  watch: {
    internalValue: {
      deep: true,
      handler: function(v) {
        this.internalValue = v;
      }
    }
  }
};
</script>
